import React, { useEffect, useState } from 'react';
import DropDown from '../../Components/Common/DropDown/DropDown';
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Checkbox,
  Button,
  Divider,
  FormControlLabel,
  RadioGroup,
  Radio
} from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { DeleteCycleForEntity, GetAllCycleForEntity, GetAllEntitiesForUserAdmin, GetAllEntitiesWithActiveCycle, ResetStatus, SubmitCycle } from '../../Reducers/dcoi';
import Spinner from '../../Components/Common/Spinner/Spinner';
import dayjs from 'dayjs';
import Toster from '../../Components/Common/Toster/Toster';
import "./ManageSubmissionCycle.css";
import { useLocation } from 'react-router-dom';

function ManageSubmissionCycle() {
  const location = useLocation();
  const CycleID = location.state?.CycleID;
  const dispatch = useDispatch();

  const [entity, SetEntity] = useState(CycleID);
  const { UpcommingCycle, AllEntitiesForUserAdmin, activeCycleEntity, inProgress } = useSelector(
    (state) => state.dcoi
  );



  const EntityData = Array.isArray(activeCycleEntity)
    ? activeCycleEntity.filter((Item) => Item.ID === entity)
    : [];

  // Initially selecting the first entity
  const [idForDelete, setIdForDelete] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endDatePreFetch, setEndDatePreFetch] = useState(null);
  const [otherEntity, setOtherEntity] = useState(false);
  const [isAuto, setIsAuto] = useState(false);
  const [otherEntityIds, setOtherEntityIds] = useState([]); // Initially selected entity is 1
  const [autoSend, setAutoSent] = useState(false);
  const [message, setMessage] = useState();
  const [alert, setAlert] = useState(false);
  const [severity, setSeverity] = useState();
  const [reminderInterval, setReminderInterval] = useState(null);
  const [selectedEntityId, setSelectedEntityId] = useState(null);

  useEffect(() => {
    dispatch(GetAllEntitiesForUserAdmin());
    dispatch(GetAllEntitiesWithActiveCycle()).then((res)=>{
      setEndDatePreFetch(dayjs(res?.payload?.data[0]?.EndTime).format("YYYY-MM-DD"))
    })
    dispatch(GetAllCycleForEntity({ Id: entity }));
  }, []);

  useEffect(() => {
    if (entity) {
      setOtherEntityIds([entity]); // Ensure the selected entity is always included
    }
  }, [entity]);



  useEffect(() => {
    // Filter upcoming cycle data for the selected entity
    const filterData = UpcommingCycle.find((item) => item.Status === "Upcoming");
    if (filterData) {
      setStartDate(dayjs(filterData.StartTime).format("YYYY-MM-DD"));
      setEndDate(dayjs(filterData.EndTime).format("YYYY-MM-DD"));
      setIdForDelete(filterData.CycleID);
    } else {
      setStartDate(null);
      setEndDate(null);
      setIdForDelete(null);
    }
  }, [UpcommingCycle, entity]); // Re-run when entity or UpcommingCycle changes


  useEffect(() => {
    if (!CycleID && AllEntitiesForUserAdmin.length > 0) {
      SetEntity(AllEntitiesForUserAdmin[0].ID); // Assuming `value` holds the dropdown option value
      dispatch(GetAllCycleForEntity({ Id: entity }));
    }
  }, [AllEntitiesForUserAdmin]);


  const handleSelectEntity = (e) => {
    SetEntity(e);
    setOtherEntity(false);
    setSelectedEntityId(e);
    setIsAuto(false);
    setOtherEntityIds([]); 
    setTimeout(() => setOtherEntityIds([e]), 0); 
    dispatch(GetAllCycleForEntity({ Id: e }));
    dispatch(GetAllEntitiesWithActiveCycle()).then((res) => {
      if (Array.isArray(res.payload?.data)) {
        const filteredItems = res.payload.data.filter((item) => item.ID === e);
        if (filteredItems.length > 0) {
          setEndDatePreFetch(dayjs(filteredItems[0]?.EndTime).format("YYYY-MM-DD"));
        }
      }
    });
  };
  
  
  useEffect(() => {
    if (EntityData.length > 0 && !endDatePreFetch) {
      setEndDatePreFetch(dayjs(EntityData[0]?.EndTime).format("YYYY-MM-DD"));
    }
  }, []); 

  useEffect(() => {
    if (EntityData.length > 0) {
      const interval = EntityData[0]?.ReminderInterval;
      setReminderInterval(interval != null ? Number(interval) : null);
    }else {
      setReminderInterval(null); // Reset if no data is available
    }
  }, [selectedEntityId]);
  

  const SubmitCyclePost = () => {
    const allEntityIds = otherEntity ? [...otherEntityIds] : [entity];
    if (entity && !otherEntityIds?.includes(entity)) {
      allEntityIds.push(entity);
    }
    const payload = {
      Status: "upcomming",
      startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
      endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
      entityids: allEntityIds,
      AutomaticallySendInvitations: autoSend,
      ReminderInterval: reminderInterval,
    };
    dispatch(SubmitCycle(payload)).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success")
        setOtherEntity(false); // Reset after submission
        setIsAuto(false);
        setOtherEntityIds([]); // Clear selected entities
        setAutoSent(false);
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.error)
        setSeverity("error")
      } else {
        setAlert(true);
        setMessage("No Data Found...")
        setSeverity("error")
      }
    });
  };

  const ResetCycle = () => {
    dispatch(ResetStatus()).then((res) => {
      if (res.payload.status === 200) {
        dispatch(GetAllEntitiesForUserAdmin());
        dispatch(GetAllEntitiesWithActiveCycle());
        dispatch(GetAllCycleForEntity({ Id: entity }));
      }
    })
  }

  const SubmitCyclePreFetch = () => {
    const payload = {
      Status: "activated",
      Id: EntityData[0]?.ID,
      startDate: EntityData[0]?.StartTime?.split("T")[0] ? dayjs(EntityData[0]?.StartTime?.split("T")[0]).format("YYYY-MM-DD") : "",
      endDate: endDatePreFetch ? dayjs(endDatePreFetch).format("YYYY-MM-DD") : "",
      AutomaticallySendInvitations: isAuto,
      ReminderInterval: reminderInterval,
    };
    dispatch(SubmitCycle(payload)).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success")
        setOtherEntity(false);
        setAutoSent(false);
        setIsAuto(false);
        setEndDatePreFetch(null);
        dispatch(GetAllEntitiesWithActiveCycle());
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.error)
        setSeverity("error")
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error")
      }
    })
  }


  const DeleteUpcommingCycle = () => {
    const payload = {
      CycleID: idForDelete
    };
    dispatch(DeleteCycleForEntity(payload)).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success")
        setOtherEntity(false);
        setAutoSent(false);
        setStartDate(null);
        setEndDate(null);
        setOtherEntityIds([]); // Clear selected entities
      } else {
        setAlert(true);
        setMessage("Something Wrong")
        setSeverity("success")
        setOtherEntity(false);
        setAutoSent(false);
      }
    })
  }

  const handleReminderChange = (event) => {
    setReminderInterval(Number(event.target.value));
  };
  return (
    <>
      <Toster
        message={message}
        severity={severity}
        alert={alert}
        setAlert={setAlert}
      />
      <Box sx={{ padding: '40px' }}>
        <Grid container spacing={2} alignItems='flex-start'>
          <Grid item xs={12} sm={8} md={6}>
            <Typography sx={{ fontWeight: 'bold', margin: '10px 0px' }}>
              Entity<span className='required'>*</span>
            </Typography>
            <DropDown
              value={entity}
              options={AllEntitiesForUserAdmin}
              onChange={handleSelectEntity}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={8}
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'right',
              paddingTop: '52px',
            }}
          >
            {/* <Typography sx={{ fontWeight: "bold", margin: "10px 0px" }}></Typography> */}
            <Button
              sx={{
                backgroundColor: ' #212129',
                color: 'white',
                borderRadius: '0px',
                padding: '10px',
              }}
              onClick={ResetCycle}
            >
              Reset Status
            </Button>
          </Grid>
        </Grid>
        <Divider sx={{ marginTop: '20px' }} />
      </Box>

      <Box sx={{ padding: '10px 0px 10px 40px' }}>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 'bold', margin: '10px 0px' }}>
            Reminder Interval
          </Typography>
          <RadioGroup
            row
            name='radio-buttons-group'
            value={reminderInterval !== null ? reminderInterval : ''} // Use null if reminderInterval is not set
            onChange={handleReminderChange}
          >
            <FormControlLabel
              value={2}
              control={<Radio />}
              label='2 Days'
            />
            <FormControlLabel
              value={3}
              control={<Radio />}
              label='3 Days'
            />
            <FormControlLabel
              value={5}
              control={<Radio />}
              label='5 Days'
            />
          </RadioGroup>
        </Grid>
      </Box>

      <Box sx={{ padding: '40px' }}>
        <Grid container spacing={2}>
          {/* Active Submission Cycle */}
          {EntityData[0] && (
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  backgroundColor: '#f5ffe8', // Light green background
                  boxShadow: 0,
                  border: '1px solid #d9f5d9',
                  borderRadius: 2,
                }}
              >
                <CardContent>
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                    color='text.primary'
                    mb={2}
                  >
                    Active Submission Cycle {'\u2705'}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography fontWeight='bold' mb={0.5}>
                        Start Date
                      </Typography>

                      <input
                        type='date'
                        value={EntityData[0]?.StartTime?.split('T')[0]} // Format as YYYY-MM-DD
                        disabled
                        className='customInputCycle'
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <Typography fontWeight='bold' mb={0.5}>
                        End Date
                      </Typography>
                      <input
                        type='date'
                        value={endDatePreFetch} // Format as YYYY-MM-DD
                        onChange={(e) => setEndDatePreFetch(e.target.value)}
                        min={
                          EntityData[0]?.StartTime?.split('T')[0] ||
                          new Date(Date.now()).toISOString().split('T')[0] ||
                          dayjs().format('YYYY-MM-DD')
                        }
                        onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                        onPaste={(e) => e.preventDefault()} // Prevent pasting a value
                        className='customInputCycle'
                      />
                    </Grid>
                  </Grid>
                  <Box display='flex' alignItems='center' mt={1.5}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={Boolean(EntityData[0]?.StartTime)}
                          checked={isAuto}
                          onChange={(e) => setIsAuto(e.target.checked)}
                        />
                      }
                      label=' Automatically send Invitations to Respondents at Cycle Start Date'
                    />
                  </Box>
                  <Box mt={2}>
                    <Button
                      disabled={!endDatePreFetch}
                      onClick={() => SubmitCyclePreFetch()}
                      sx={{
                        backgroundColor: !endDatePreFetch ? '#ccc' : ' #212129',
                        color: 'white',
                        padding: '10px',
                        borderRadius: '0px',
                        '&:hover': {
                          backgroundColor: !endDatePreFetch
                            ? '#ccc'
                            : ' #212129',
                          opacity: 0.5,
                        },
                      }}
                    >
                      Update
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {/* Upcoming Submission Cycle */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                backgroundColor: '#f7f9fc',
                boxShadow: 0,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
              }}
            >
              <CardContent>
                <Typography
                  variant='h6'
                  fontWeight='bold'
                  color='text.primary'
                  mb={2}
                >
                  Upcoming Submission Cycle
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography fontWeight='bold' mb={0.5}>
                      Start Date
                    </Typography>
                    <input
                      type='date'
                      value={
                        startDate ? dayjs(startDate).format('YYYY-MM-DD') : ''
                      }
                      onChange={(e) => setStartDate(e.target.value)}
                      className='customInputCycle'
                      min={dayjs().format('YYYY-MM-DD')} // Disable past dates
                      onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                      onPaste={(e) => e.preventDefault()} // Prevent pasting a value
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight='bold' mb={0.5}>
                      End Date
                    </Typography>
                    <input
                      type='date'
                      value={endDate ? dayjs(endDate).format('YYYY-MM-DD') : ''} // Keep input value in YYYY-MM-DD format
                      onChange={(e) => setEndDate(e.target.value)} // Handle date selection
                      onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                      onPaste={(e) => e.preventDefault()} // Prevent pasting a value
                      className='customInputCycle'
                      min={startDate || dayjs().format('YYYY-MM-DD')} // Ensure end date is after start date
                    />
                  </Grid>
                </Grid>
                <Box display='flex' alignItems='center' mt={1.5}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={otherEntity}
                        onChange={(e) => setOtherEntity(e.target.checked)}
                      />
                    }
                    label='Apply Start Date and End Date to other entities'
                  />
                </Box>
                <Box>
                  {otherEntity && (
                    <Box
                      container
                      sx={{
                        margin: '20px',
                        backgroundColor: 'white',
                        padding: '5px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '80%',
                      }}
                    >
                      {AllEntitiesForUserAdmin &&
                        AllEntitiesForUserAdmin?.filter(
                          (Item) => Item.id !== entity
                        )?.map((Item) => (
                          <Grid
                            item
                            xs={12}
                            key={Item.Label}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'left',
                              padding: '5px',
                            }}
                          >
                            <Checkbox
                              value={Item.id}
                              checked={otherEntityIds.includes(Item.id)} // Check if the ID is in the array
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setOtherEntityIds((prev) => [
                                    ...prev,
                                    Item.id,
                                  ]);
                                } else {
                                  setOtherEntityIds((prev) =>
                                    prev.filter((id) => id !== Item.id)
                                  );
                                }
                              }}
                            />
                            {Item.Label}
                          </Grid>
                        ))}
                    </Box>
                  )}
                </Box>
                <Box display='flex' alignItems='center'>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={autoSend}
                        onChange={(e) => setAutoSent(e.target.checked)}
                      />
                    }
                    label=' Automatically send Invitations to Respondents at Cycle Start Date'
                  />
                </Box>
                <Box mt={2}>
                  <Button
                    disabled={!startDate || !endDate}
                    onClick={SubmitCyclePost}
                    sx={{
                      backgroundColor:
                        !startDate || !endDate ? '#ccc' : ' #212129',
                      color: 'white',
                      padding: '10px',
                      borderRadius: '0px',
                      '&:hover': {
                        backgroundColor:
                          !startDate || !endDate ? '#ccc' : ' #212129',
                        opacity: 0.5,
                      },
                    }}
                  >
                    Save
                  </Button>
                  &nbsp;
                  {idForDelete && (
                    <Button
                      disabled={!startDate || !endDate}
                      onClick={DeleteUpcommingCycle}
                      sx={{
                        backgroundColor:
                          !startDate || !endDate ? '#ccc' : ' #212129',
                        color: 'white',
                        padding: '10px',
                        borderRadius: '0px',
                        '&:hover': {
                          backgroundColor:
                            !startDate || !endDate ? '#ccc' : ' #212129',
                          opacity: 0.5,
                        },
                      }}
                    >
                      Delete
                    </Button>
                  )}
                </Box>
                <Typography
                  variant='caption'
                  color='text.secondary'
                  display='block'
                  mt={2}
                >
                  <Box component='span' fontStyle='italic'>
                    Administrator can send invitation manually on Send
                    Invitation/Reminder page.
                  </Box>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default ManageSubmissionCycle